/* eslint-disable @typescript-eslint/no-unused-vars */
import storeInfo from '../store'
import { Invitation } from './types'

export const getInvitations = () => (): Invitation[] => {
    const { invitations: { invitations } } = storeInfo.store.getState()
    return invitations
}
